<template>
  <header class="safeguard-header">
    <v-container class="py-0">
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2" class="py-0">
          <div class="safeguard-header-inner">
            <router-link :to="{ name: 'Home' }" class="safeguard-header-title">{{ title }}</router-link>
            <nav class="safeguard-header-menu">
              <a v-for="menu in menus" :key="menu.pathName" :href="homepageUrl(menu.pathName)" target="_blank" rel="noopener noreferrer">{{ menu.title }}</a>
            </nav>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </header>
</template>

<script>
import { FB_HOMEPAGE_URL, SAFEGUARD_SITE_TITLE, safeguardMenus } from "@/assets/js/safeguardSite";

// 세이프가드 홈페이지 전용 헤더 (Figma 「서비스-세이프가드·금융사기방지 개별페이지」 navigation)
export default {
  name: "SafeguardGnb",
  data() {
    return {
      title: SAFEGUARD_SITE_TITLE,
      menus: safeguardMenus
    };
  },
  methods: {
    // 상단 메뉴는 핀브릿지 홈페이지 도메인의 같은 화면을 새 창으로 연다
    homepageUrl(pathName) {
      return FB_HOMEPAGE_URL + this.$router.resolve({ name: pathName }).href;
    }
  }
};
</script>

<style lang="scss" scoped>
.safeguard-header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 200;
  background-color: #fff;
  border-bottom: 1px solid #f0f3f5;

  &-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    height: 56px;
    padding: 0 18px;
  }

  &-title {
    font-size: 15px;
    white-space: nowrap;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: -1px;
    color: #001523;
    text-decoration: none;
  }

  &-menu {
    display: flex;
    gap: 10px;

    a {
      font-size: 12px;
      white-space: nowrap;
      font-weight: 500;
      color: #001523;
      text-decoration: none;
    }
  }

  @include respond-to("small") {
    &-inner {
      padding: 0 30px;
    }
  }

  @include respond-to("medium") {
    &-inner {
      gap: 0;
      height: 100px;
      padding: 0;
    }

    &-title {
      font-size: 25px;
      line-height: 40px;
      letter-spacing: -2px;
    }

    &-menu {
      justify-content: space-between;
      gap: 0;
      width: 340px;

      a {
        font-size: 16px;
      }
    }
  }
}
</style>
